import { responseHandler } from "../_heleper/response-handler";
import {url, cookie_env} from "./apiurl"
import {authHeader} from '../_heleper/auth-header'

const authApi = {
  sendRegistrationOtp: (email) => fetch(`${url}/auth/customer/registration-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  }).then(responseHandler),


  session: () => {
    const reqOptions = {
      method: "GET",
      headers: {...authHeader(), "Content-Type": "application/json" },           
    };
    return fetch(`${url}/user/session`, reqOptions).then(responseHandler);
  },

  login: (data) => {
    const reqOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };
    return fetch(
      `${url}/auth/customer/login`,
      reqOptions
    ).then(responseHandler).then(data=>{
      // sessionStorage.setItem('accessToken', JSON.stringify(data.token));
      if(data.token){
        if(cookie_env === 'prod'){
          document.cookie = "tk="+data.token+"; path=/; domain=.myuaestartup.com; Secure; SameSite=None";
        }
        else{
          document.cookie = "tk="+data.token+"; path=/;"
        }        
      }    
      return data;
    });
  },
  
  register: (data) => {
    const reqOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };
    return fetch(
      `${url}/auth/customer/register-login`,
      reqOptions
    ).then(responseHandler).then(data=>{
      // sessionStorage.setItem('accessToken', JSON.stringify(data.token));
      if(data.token){
        if(cookie_env === 'prod'){
          document.cookie = "tk="+data.token+"; path=/; domain=.myuaestartup.com; Secure; SameSite=None";
        }
        else{
          document.cookie = "tk="+data.token+"; path=/;"
        }        
      }    

      return data;
    });
  },

  vendorRegister: (data) => {
    const reqOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };
    return fetch(
      `${url}/auth/customer/register/vendor`,
      reqOptions
    ).then(responseHandler)
  },

  agentRegister: (data) => {
    const reqOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };
    return fetch(
      `${url}/auth/customer/register/agent`,
      reqOptions
    ).then(responseHandler)
  },

  quickRegister: (data) => {
    const reqOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };
    return fetch(
      `${url}/auth/customer/register-quick`,
      reqOptions
    ).then(responseHandler);
  },

  getProfile: () => {
    const reqOptions = {
      method: "GET",
      headers: {...authHeader(), "Content-Type": "application/json" },      
    };
    return fetch(
      `${url}/auth/customer/profile`,
      reqOptions
    ).then(responseHandler);
  },

  updateProfile: (data) => {
    const reqOptions = {
      method: "PUT",
      headers: {...authHeader(), "Content-Type": "application/json" },
      body:JSON.stringify(data)      
    };
    return fetch(
      `${url}/auth/customer/profile`,
      reqOptions
    ).then(responseHandler);
  },

  addWishlist:(data)=>{
    const reqOptions = {
      method:'PUT',
      headers:{...authHeader(), "Content-Type":"application/json"},
      body:JSON.stringify(data)
    }
    return fetch(`${url}/auth/customer/wishlist-add`, reqOptions).then(responseHandler)
  },
  
  removeWishlist:(data)=>{
    const reqOptions = {
      method:"PUT",
      headers:{...authHeader(), "Content-Type":"application/json"},
      body:JSON.stringify(data)
    }
    return fetch(`${url}/auth/customer/wishlist-rm`, reqOptions).then(responseHandler)
  },
  resetPassword:(data)=>{
    const reqOptions = {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify(data)
    }
    return fetch(`${url}/auth/customer/reset-password`, reqOptions).then(responseHandler)
  },
  updatePassword:(data)=>{
    const reqOptions = {
      method:"POSt",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify(data)
    }
    return fetch(`${url}/auth/customer/update-password`, reqOptions).then(responseHandler)
  }
};

export default authApi;
